import React, { useRef } from "react";
import { useSelector } from "react-redux";
import { formattedAmount } from "../../../../utils/helpers/Functions.helper";
import { BsTelephone } from "react-icons/bs";
import { CiLocationOn } from "react-icons/ci";

function OrderInvoice({ invoiceData }) {
  const { theme } = useSelector((state) => state.theme);

  const componentRef = useRef();

  const handlePrint = () => {
    console.log("componentRef.current", componentRef.current);
    if (componentRef.current) {
      const printableContent = componentRef.current.innerHTML;
      const printWindow = window.open("", "_blank");

      // Creating the HTML for the print window with internal styles and Tailwind CSS
      printWindow.document.open();
      printWindow.document.write(`
        <html>
          <head>
            <title>Invoice</title>
            <style>
            @media print {
  body {
    font-family: Arial, sans-serif;
  }
    #print_btn{
    display:none;}
  .printable {
    width: 44mm;
    margin: 0 auto;
    background: #fff;
    padding: 10px;
    box-shadow: 0 0 1in -0.25in rgba(0, 0, 0, 0.5);
  }

  table {
    width: 100%;
    border-collapse: collapse;
  }

  th, td {
    padding: 8px;
    text-align: left;
  }

  th {
    background-color: #f3f3f3;
  }

  .text-center {
    text-align: center;
  }

  .font-bold {
    font-weight: bold;
  }

  .logo {
    height: 50px;
    width: 50px;
    background: url('your-logo-url') no-repeat center;
    background-size: contain;
  }

  #top .info h2 {
    margin: 0;
    font-size: 1.2em;
  }

  #top {
    margin-bottom: 10px;
  }

  #bot {
    margin-top: 10px;
  }

  #bot td, #bot th {
    font-size: 0.8em;
  }
  }

            </style>
          </head>
          <body>
            ${printableContent}
          </body>
        </html>
      `);
      printWindow.document.close();
      printWindow.print();
    } else {
      console.error("Ref is not available");
    }
  };

  const {
    totalPrice,
    totalCancelledPrice,
    totalDeliveryFee,
    totalCancelledDeliveryFee,
    totalDeliveryVat,
    totalProductVat,
    totalTax,
    deliveryTax,
  } = invoiceData?.orderDetails?.reduce(
    (acc, d) => {
      if (d?.delivery_status === "CANCELLED") {
        acc.totalCancelledPrice += ((+d?.product?.taxData?.grandTotal?.$numberDecimal||+d?.product?.taxData?.grandTotal?.$numberDecimal||0)*(+d?.quantity)) ;        
        acc.totalCancelledDeliveryFee +=
          +d?.delivery_fee?.totalDeliveryFee || 0;
        acc.totalcancelledProductVat +=
          +d?.product?.taxData?.vat?.[0]?.taxAmount
            ?.$numberDecimal;
        acc.totalcancelledDeliveryVat += +d?.delivery_fee?.vat?.taxAmount;
      } else {
        acc.totalPrice += ((+d?.product?.taxData?.grandTotal?.$numberDecimal||+d?.product?.taxData?.grandTotal?.$numberDecimal||0)*(+d?.quantity)) ;
        acc.totalProductVat +=
          +d?.product?.taxData?.vat?.[0]?.taxAmount
            ?.$numberDecimal;
        acc.totalDeliveryVat += +d?.delivery_fee?.vat?.taxAmount;
        acc.deliveryTax = {
          name: d?.delivery_fee?.vat?.name,
          rate: d?.delivery_fee?.vat?.rate,
          taxAmount: d?.delivery_fee?.vat?.taxAmount,
        };
        acc.totalDeliveryFee +=d?.delivery_fee?.totalDeliveryFee
        acc.totalTax +=
          +(+d?.product?.taxData?.vat?.[0]?.taxAmount
            ?.$numberDecimal) + +d?.delivery_fee?.vat?.taxAmount;
      }
      return acc;
    },
    {
      totalPrice:0,
      totalCancelledPrice: 0,
      totalDeliveryFee:0,
      totalCancelledDeliveryFee: 0,
      totalTax: 0,
      totalProductVat: 0,
      totalDeliveryVat: 0,
      deliveryTax: null,
    } // Initialize both variables
  );

  console.log('invoiceData:', invoiceData);
  // console.log('Total Cancelled Delivery Fee:', totalCancelledDeliveryFee);

  // Safe default values
  const orderId = invoiceData?.order_id || "N/A";
  const totalItemPrice =totalPrice  
  const deliveryPrice = totalDeliveryFee

  const tipAmount = parseFloat(
    invoiceData?.tip_amount?.$numberDecimal || 0
  ).toFixed(2);
  const netTotal = (+totalItemPrice)+(+deliveryPrice)

  // delivery Details
  const delivery_address = invoiceData?.delivery_address;

  return (
    <div
      ref={componentRef}
      className={`p-6 rounded-lg shadow-lg mx-auto transition-all duration-300 ${
        theme === "light"
          ? "bg-secondaryColor text-textColorLight"
          : "bg-darkThirsary text-darkSecondary"
      }`}
    >
      <div className="mb-6">
        <h3 className="font-semibold mb-2 text-lg">Order by</h3>
        <p className="text-xl font-semibold hover:text-blue-900 transition duration-300">
          {delivery_address?.name ?? "N/A"}
        </p>
        <div className="flex justify-between items-center mt-1">
          <p
            style={{ display: "flex", gap: "1rem" }}
            className="text-gray-500 text-xl hover:text-blue-900 transition duration-300"
          >
            <BsTelephone className="text-2xl text-blue-900 hover:text-blue-700 transition duration-300" />
            {delivery_address?.phone_number ?? "N/A"}
          </p>
        </div>

        <div className="flex items-center p-2 gap-4 mt-4 bg-gray-100 rounded-lg shadow-sm">
          <p style={{ display: "flex", gap: "1rem" }} className="text-gray-700">
            <CiLocationOn className="text-3xl text-blue-900" />
            {delivery_address?.flat_no ?? "N/A"},{" "}
            {delivery_address?.landmark ?? "N/A"},
            {delivery_address?.street ?? "N/A"},{" "}
            {delivery_address?.pin_code ?? "N/A"}
          </p>
        </div>
      </div>
      <hr />
      <div style={{display:'flex',justifyContent:'space-between', color: "", fontStyle: "italic" }}>
        <p>#Invoice {orderId}</p>
        <p>Total: {formattedAmount(netTotal)}</p>
      </div>

      <div className="border-t border-gray-200 pt-4">
        <table className="w-full text-left text-sm">
          <thead>
            <tr className="">
              <th className="font-medium  py-2">ORDER DETAILS</th>
              <th className="font-medium  py-2 text-right">
                Quantity
              </th>
              <th className="font-medium  py-2 text-right">
                Base Price
              </th>
              <th className="font-medium  py-2 text-right">Tax</th>
              <th className="font-medium  py-2 text-right">
                Tax Amount
              </th>
              <th className="font-medium  py-2 text-right">
                Price
              </th>
              <th className="font-medium  py-2 text-right">
                Total
              </th>
            </tr>
          </thead>
          <tbody>
            {invoiceData?.orderDetails?.length > 0 ? (
              invoiceData.orderDetails.map((order) => (
                <tr
                style={
                  order?.delivery_status === "CANCELLED"
                    ? { textDecoration: "line-through" }
                    : {}
                 }
                  key={order._id}
                  className={`${
                    order?.delivery_status === "CANCELLED"
                      ? "text-red-600 line-through"
                      : ""
                  } "hover:bg-gray-50"`}
                >
                  <td className={`${theme?"":"text-gray-300"} py-2 pr-8 w-[15rem]`}>
                    {order.product?.name || "N/A"}
                  </td>
                  <td className={`text-center ${theme?"":"text-gray-300"}`}>{order.quantity}</td>
                  <td className={`text-right px-2 ${theme?"":"text-gray-300"} `}>
                    {formattedAmount(
                      parseFloat(
                        +order?.product?.taxData?.taxableAmount
                          ?.$numberDecimal||+order?.product?.taxData?.taxableAmount?.$numberDecimal||0
                      ).toFixed(2)
                    )}
                  </td>
                  <td className={`text-right px-2 ${theme?"":"text-gray-300"} `}>
                    {order?.product?.taxData?.vat?.[0]?.name}@
                    {
                      order?.product?.taxData?.vat?.[0]?.rate
                        ?.$numberDecimal
                    }
                  </td>
                  <td className={`text-right px-2 ${theme?"":"text-gray-300"} `}>
                    {
                      formattedAmount(order?.product?.taxData?.vat?.[0]
                        ?.taxAmount?.$numberDecimal)
                    }
                  </td>
                  <td className={`text-right px-2 ${theme?"":"text-gray-300"} `}>
                    {formattedAmount(  +order?.product?.taxData?.grandTotal?.$numberDecimal)}
                  </td>
                  <td className={`text-right px-2 ${theme?"":"text-gray-300"} `}>
                    {formattedAmount(+order?.product?.taxData?.grandTotal?.$numberDecimal * +order.quantity)}
                  </td>
                </tr>
              ))
            ) : (
              <tr>
                <td colSpan={3} className="py-2 text-center text-gray-500">
                  No order details available
                </td>
              </tr>
            )}
          </tbody>
        </table>
      </div>    
      <div
        style={{
          borderTop: "1px solid #E5E7EB",
          marginTop: "1rem",
          paddingTop: "1rem",
        }}
      >
        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
            fontSize: "0.875rem",
            marginBottom: "0.5rem",
          }}
        >
          <span>Cart total :</span>
          <span>{formattedAmount(totalItemPrice)}</span>
        </div>
        <hr />
        <h3 style={{ fontSize: "1rem", fontWeight: "bold" }}>
          Delivery Details:
        </h3>
        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
            fontSize: "0.875rem",
            marginBottom: "0.5rem",
          }}
        >
          <span>Total Delivery price :</span>
          <span>
            {formattedAmount(+deliveryPrice - +deliveryTax?.taxAmount)}
          </span>
        </div>
        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
            fontSize: "0.875rem",
            marginBottom: "0.5rem",
          }}
        >
          <span>{deliveryTax?.name} :</span>
          <span>{deliveryTax?.rate}%</span>
          <span>{deliveryTax?.taxAmount}</span>
        </div>
        <hr />
        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
            fontSize: "0.875rem",
            marginBottom: "0.5rem",
          }}
        >
          <span>Total Delivery price :</span>
          <span>{formattedAmount(deliveryPrice)}</span>
        </div>
        <hr />
        {Number(tipAmount) !== 0 ? (
          <div
            style={{
              display: "flex",
              justifyContent: "space-between",
              fontSize: "0.875rem",
              marginBottom: "0.5rem",
            }}
          >
            <span>Tip amount :</span>
            <span>₹ {tipAmount}</span>
          </div>
        ) : (
          ""
        )}
        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
            fontSize: "0.875rem",
            fontWeight: "600",
            marginTop: "0.5rem",
            paddingTop: "0.5rem",
          }}
        >
          <span>Total:</span>
          <span>{formattedAmount(netTotal)}</span>
        </div>
      </div>
      {/* Print button */}
      <button
        id="print_btn"
        onClick={handlePrint}
        className="px-4 py-2 my-4 btn"
      >
        Print as PDF
      </button>
    </div>
  );
}

export default OrderInvoice;
